import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { IconError } from "../../Assets/IconError";
import { IconEye } from "../../Assets/IconEye";
import { IconEyeslash } from "../../Assets/IconEyeslash";
import { Tooltip } from "./Tooltip";
import DatePicker, { DateObject } from 'react-multi-date-picker';
import persian from "react-date-object/calendars/persian";
import gregorian from "react-date-object/calendars/gregorian";
import persian_fa from "react-date-object/locales/persian_fa";
import persian_en from "react-date-object/locales/persian_en";
import gregorian_en from "react-date-object/locales/gregorian_en";
import "react-multi-date-picker/styles/layouts/mobile.css"

const Styles = styled.div`
  width: 100%;
  position: relative;
  .rmdp-container  {
    width: 100%;
  }
  &.ltr-all {
    .label-textinput{
      right: auto;
      left: 1rem;
    }
  }
  .text-field{
    width: calc(100% - 2rem);
    padding: calc(var(--fs-textfield) * 2.3) calc(1rem - 1px) calc(var(--fs-textfield) * 0.7);
    border-radius: var(--border-radius-2);
    border: 1px var(--n-grey-2) solid;
    outline: none;
    transition: var(--trans-1);
    font-size: var(--fs-textfield);
    background: transparent;
    height: calc(var(--fs-textfield) * 1.23);
    &.disabled {
      background-color: var(--n-grey-01);
      color: var(--n-grey-5);
    }
    &.no-border {
      border: 1px solid #FFFFFF00;
    }
  }
  .label-textinput{
    position: absolute;
    z-index: 5;
    top: calc(var(--fs-textfield) * 0.5);
    right: 1rem;
    font-size: calc(var(--fs-textfield) * 0.8);
    transition: var(--trans-1);
    &.disabled {
      color: var(--n-grey-5);
    }
  }
  .error {
    display: flex;
    height: 1rem;
    font-size: var(--fs-small);
    .icon {
      width: 1rem;
      height: 1rem;
    }
    .text {
      margin: 0.1rem 0.2rem 0 0;
      color: red;
    }
  }
  @media screen and (max-width: 1445px) {
    .text-field {
      padding: calc(var(--fs-textfield) * 1.6) calc(1rem - 1px) calc(var(--fs-textfield) * 0.5);
    }
  }
`;

// dokme chesm baray ramz ha
export const DateInputWTitle = ({
  style,
  name,
  error,
  value,
  dvalue,
  onchange,
  title,
  required,
  ltr,
  center,
  disabled,
  minDate,
  maxDate,
  lan=false,
  noError = false,
  className = "",
  range=false
}) => {
  const [testDate, setTestDate] = useState((range) ? [
      new DateObject().subtract(3, "days"),
      new DateObject().add(3, "days")
    ] :
    new DateObject()
  );
  useEffect(() => {
    if(!value) {
      if(range){
        let dates = [];
        for (let i = 0; i < testDate.length; i++) {
          const element = testDate[i];
          element.setLocale(gregorian_en)
          element.setCalendar(gregorian)
          dates[i] = element.format("YYYY-MM-DD")
        }
        onchange({
          target: {
            value: dates.join(" | "),
            name: name,
          }
        })
      } else {
        let newValue = new DateObject({calendar: gregorian, locale: gregorian_en});
        newValue.setFormat("YYYY-MM-DD");
        newValue.setLocale(gregorian_en)
        newValue.setCalendar(gregorian)
        onchange({
          target: {
            value: newValue.format("YYYY-MM-DD"),
            name: name,
          }
        })
      }
    } else {
      if(range){
        let values = value.split(" | ");
        let newValue1 = new DateObject({calendar: gregorian, locale: gregorian_en});
        let newValue2 = new DateObject({calendar: gregorian, locale: gregorian_en});
        newValue1.setFormat("YYYY-MM-DD");
        newValue1.parse(values[0]);
        newValue2.setFormat("YYYY-MM-DD");
        newValue2.parse(values[1]);
        setTestDate([newValue1, newValue2]);
      } else {
        let newValue = new DateObject({calendar: gregorian, locale: gregorian_en});
        newValue.setFormat("YYYY-MM-DD");
        newValue.parse(value);
        setTestDate(newValue);
      }
    }
  }, []);
  useEffect(() => {
    if(!value) {
      if(range){
        let dates = [];
        for (let i = 0; i < testDate.length; i++) {
          const element = testDate[i];
          element.setLocale(gregorian_en)
          element.setCalendar(gregorian)
          dates[i] = element.format("YYYY-MM-DD")
        }
        onchange({
          target: {
            value: dates.join(" | "),
            name: name,
          }
        })
      } else {
        let newValue = new DateObject({calendar: gregorian, locale: gregorian_en});
        newValue.setFormat("YYYY-MM-DD");
        newValue.setLocale(gregorian_en)
        newValue.setCalendar(gregorian)
        onchange({
          target: {
            value: newValue.format("YYYY-MM-DD"),
            name: name,
          }
        })
      }
    }
  }, [value])
  const onChangeValue = (e) => {
    if(range){
      setTestDate(e);
      let dates = [];
      for (let i = 0; i < e.length; i++) {
        const element = e[i];
        element.setLocale(gregorian_en)
        element.setCalendar(gregorian)
        dates[i] = element.format("YYYY-MM-DD")
      }
      onchange({
        target: {
          value: dates.join(" | "),
          name: name,
        }
      })
    } else {
      e.setLocale(gregorian_en)
      e.setCalendar(gregorian)
      onchange({
        target: {
          value: e.format("YYYY-MM-DD"),
          name: name,
        }
      })
    }
  }
  let errorComp = "";
  let classes = "text-field";
  if (error && error.toString()) {
    classes = "text-field error-text";
    errorComp = (
      <React.Fragment>
        <IconError />
        <div className="text">{error}</div>
      </React.Fragment>
    );
  }

  if (ltr) {
    classes += " ltr-text";
  }

  if (center) {
    classes += " center-text";
  }
  if (disabled) {
    classes += " disabled";
  }
  
  let baseCalender = gregorian;
  let language = gregorian_en;
  // if(!lan){
  //   baseCalender = persian;
  //   language = persian_fa;
  // }
  let newValue = new DateObject({calendar: gregorian, locale: gregorian_en});
  if(value){
    newValue.setFormat("YYYY-MM-DD");
    newValue.parse(value)
  }
  return (
    <Styles style={style} className={(lan) ? "ltr-all" : ""}>
      <DatePicker
        inputClass={"rmdp-input "+ classes + " " + className}
        className={((window.innerWidth < 850) ? "rmdp-mobile " : "")}
        name={name}
        required={required}
        disabled={disabled}
        // calendarPosition="bottom"

        dvalue={maxDate+1}
        
        minDate={minDate}
        maxDate={maxDate}
        calendar={baseCalender} 
        locale={language} 
        value={(range) ? testDate : newValue} 
        onChange={onChangeValue} 
        range={range}
        rangeHover={range}
      />
      <label className={"label-textinput " + ((disabled) ? 'disabled' : '')}>
        {title}
      </label>
      {
        (!noError) ? (
          <div className="error">{errorComp}</div>
        ) : ""
      }
    </Styles>
  );
};


export const langDateChange = (date) => {
  let newValue1 = new DateObject({calendar: gregorian, locale: gregorian_en});
  newValue1.setFormat("YYYY-MM-DD");
  newValue1.parse(date);
  return newValue1.format("YYYY/MM/DD");
}
export const langDateChangeWithLan = (date, lang) => {
  let newValue1 = new DateObject({calendar: gregorian, locale: gregorian_en});
  newValue1.setFormat("YYYY-MM-DD");
  newValue1.parse(date);
  if(lang === "fa"){
    newValue1.setCalendar(persian)
    newValue1.setLocale(persian_fa)
  }
  return newValue1.format("YYYY/MM/DD");
}
////////////////////